export function getGameDownloadUrl(orderItemId: string, isGamesApp: boolean) {
  const brand = process.env.NEXT_PUBLIC_DEFAULT_DP;
  const DP = process.env.NEXT_PUBLIC_DEFAULT_DP;
  return isGamesApp
    ? `wtapp://wildtangent.com/1/${DP}/play/${orderItemId}`
    : `https://download.wildgames.com/gamesapp/TouchpointInstallers/${brand}/Setup-${orderItemId}-${DP}.exe`;
}
